import React from 'react'

import LeadsPage from '../../screens/LeadsPage/LeadsPage.component'

const LeadsRoute: React.FC = () => {
  return <LeadsPage />
}

export default LeadsRoute
